import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home-page/home.component';
import { AboutComponent } from './pages/about-page/about.component';
import { ServicesComponent } from './pages/services-page/services.component';
import { ContactComponent } from './pages/contact-page/contact.component';
import { DetailsPageComponent } from './pages/details-page/details-page.component';
import { PricingComponent } from './pages/pricing-page/pricing.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { VersionComponentComponent } from './root-components/version-component/version-component.component';
import { AboutUsResolver } from './pages/about-page/resolvers/about-us.resolver';
import { DetailsPageResolver } from './pages/details-page/resolvers/detailsPageResolver';
import { HomeResolver } from './pages/home-page/resolvers/home.resolver';
import { ServiceResolver } from './pages/services-page/resolvers/services.resolver';
import { PricingResolver } from './pages/pricing-page/resolvers/pricing.resolver';
import { CourseComponent } from './pages/course/course.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/otp-code/otp-code.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { AuthGuard } from './pages/auth/services/auth/auth.guard';
import { CoursePageResolver } from './pages/course/resolvers/coursePageResolver';
import { PaymentGuard } from './pages/payment/services/payment/payment.guard';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { ArticleDetailsComponent } from './pages/articles/components/article-details/article-details.component';

const routes: Routes = [
  { path: '', redirectTo: '/ar/home', pathMatch: 'full' },
  {
    path: ':lang/home',
    component: HomeComponent,
    resolve: { homeData: HomeResolver },
  },
  {
    path: ':lang/about',
    component: AboutComponent,
    resolve: { aboutData: AboutUsResolver },
  },  {
    path: ':lang/articles',
    component: ArticlesComponent
  }, {
    path: ':lang/articles/:id',
    component: ArticleDetailsComponent
  },
  {
    path: ':lang/services',
    component: ServicesComponent,
    resolve: { serviceData: ServiceResolver },
  },
  { path: ':lang/contact', component: ContactComponent },
  { path: ':lang/policy', component: PolicyPageComponent },
  { path: ':lang/refund-policy', component: RefundPolicyPageComponent },
  { path: ':lang/details', component: DetailsPageComponent },
  {
    path: ':lang/details/:pagename/:filename/:title',
    component: DetailsPageComponent,
    resolve: { article: DetailsPageResolver },
  },
  {
    path: ':lang/pricing',
    component: PricingComponent,
    resolve: { pricingData: PricingResolver },
  },
  { path: ':lang/payment', component: PaymentComponent },
  { path: 'version', component: VersionComponentComponent },
  {
    path: ':lang/course/:name',
    component: CourseComponent,
    resolve: { course: CoursePageResolver },
    canActivate: [AuthGuard, PaymentGuard],
  },
  {
    path: ':lang/course/:name/:video',
    component: CourseComponent,
    resolve: { course: CoursePageResolver },
    canActivate: [AuthGuard, PaymentGuard],
  },
  {
    path: ':lang/profile/:component',
    component: ProfilePageComponent,
    canActivate: [AuthGuard],
  },
  { path: ':lang/login', component: LoginComponent, canActivate: [AuthGuard] },
  {
    path: ':lang/signup',
    component: SignUpComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/forgetPassword',
    component: ForgetPasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/resetPassword',
    component: ResetPasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: ':lang/verify-otp',
    component: OtpCodeComponent,
    canActivate: [AuthGuard],
  },

  { path: '**', component: HomeComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    initialNavigation: 'enabledBlocking',
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
